export function storesIsOpenForBusiness(store) {
  return store.open_for_business;
}
